import { render, staticRenderFns } from "./data-subject-back-button.vue?vue&type=template&id=3f209ba7"
import script from "./data-subject-back-button.vue?vue&type=script&lang=js"
export * from "./data-subject-back-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports